import React from 'react';
import { SuccessStatusIcon, WarningStatusIcon } from 'components/SVG';
import { SparkAccordion } from 'sharedComponents/UI';
import { Avatar, Box, Divider } from '@mui/material';
import { useSparkStepByID } from 'hooks/SparkBuilder/sparkStep';
import { useAddSparkTest } from 'hooks/SparkBuilder/useAddSparkTest';
import { useSparkBuilderStore } from 'stores';
import type { DialogConfig } from 'hooks/common/useDialog';
import type { StepTest } from 'types/SparkStep';
import SparkTestsTabs from './SparkTestsTabs';

type TestAccordionProps = {
  hasTestIssues: boolean;
  sparkTestResults: StepTest | null;
  dialogConfig?: DialogConfig;
  outputTypeID?: string | null;
  handleContinue: () => void;
};
function TestAccordion({
  hasTestIssues,
  sparkTestResults,
  dialogConfig,
  handleContinue,
  outputTypeID,
}: TestAccordionProps) {
  const currentStep = useSparkBuilderStore(
    (store) => store.builderSideBar.selectedStep
  );
  const outputBoardID = useSparkBuilderStore(
    (store) => store.joinedSpark?.attributes.outputBoardID
  );
  const {
    mutateAsync: addTestRecord,
    isLoading: isAddTestRecordLoading,
    reset: resetAddStepQuery,
    error: addStepError,
    data: addStepData,
  } = useAddSparkTest(currentStep?.id, outputBoardID);

  const { isLoading: isSparkStepLoading, isFetching: isSparkStepFetching } =
    useSparkStepByID(currentStep?.id);

  const handleTestClick = async () => {
    resetAddStepQuery();
    try {
      await addTestRecord();
    } catch (error) {
      throw new Error('Spark step test error');
    }
  };

  /*
    removed 'isSparkStepFetching' from loading variable, 
    as it cause test section to re-load if we do change 
    only title of the spark. if needed back, destructure 
    isFetching from useSparkStepByID
   */

  const isLoading =
    isAddTestRecordLoading || isSparkStepLoading || isSparkStepFetching;
  return (
    <>
      <SparkAccordion
        sx={{ border: 'none' }}
        title='Test'
        accordionTitleStyles={{
          fontSize: '1.5em',
        }}
        dialogConfig={dialogConfig}
        summaryStyles={{ paddingX: 2, paddingY: 1, cursor: 'pointer' }}
        detailsStyle={{ paddingBottom: 2 }}
        icon={
          <Avatar
            sx={{
              width: '30px',
              height: '30px',
            }}
          >
            {hasTestIssues ? (
              <WarningStatusIcon width='100%' height='100%' />
            ) : (
              <SuccessStatusIcon width='100%' height='100%' />
            )}
          </Avatar>
        }
      >
        <SparkTestsTabs
          handleTestClick={handleTestClick}
          isParentLoading={isLoading}
          isAddTestRecordLoading={isAddTestRecordLoading}
          sparkTestResults={sparkTestResults}
          onContinue={handleContinue}
          addStepError={addStepError as Error}
          addStepData={addStepData}
          outputTypeID={outputTypeID}
        />
      </SparkAccordion>
      <Box width='100%'>
        <Divider />
      </Box>
    </>
  );
}

export default TestAccordion;
